/**
 * Created by lovo_bdk on 15-12-17.
 */
(function (win, doc) {
    function setFontSize() {
        var winWidth = window.innerWidth
        if (/Android | webOS | iPhone | iPod | BlackBerry/i.test(navigator.userAgent)) {
            doc.documentElement.style.fontSize = (winWidth / 750) * 100 + 'px'
        } else {
            doc.documentElement.style.fontSize = 75 + 'px'
        }
    }

    var evt = 'onorientationchange' in win ? 'orientationchange' : 'resize'
    var timer = null
    win.addEventListener(evt, function () {
        clearTimeout(timer)

        timer = setTimeout(setFontSize, 300)
    }, false)
    win.addEventListener('pageshow', function (e) {
        if (e.persisted) {
            clearTimeout(timer)
            timer = setTimeout(setFontSize, 300)
        }
    }, false)
    // 初始化
    setFontSize()
})(window, document)
